import React from "react";
import Navauth from "../partials/navauth";
import { NavLink } from "react-router-dom";

const updated = () => {
  return (
    <div>
      <Navauth />
      <div className="container">
        <div className="row lg:px-[160px]">
          <div className="col-lg-12">
            <h3 className="header-signup lg:text-[30px] text-[22px] whitespace-nowrap md:text-[40px] mt-16">
              Password Update
            </h3>

            <div className="row padding-form">
              <div className="col-md-6 col-12">
                <input
                  className="input-z"
                  placeholder="Enter New password"
                  type="text"
                />
              </div>

              <div className="col-md-6 col-12">
                <input
                  className="input-z"
                  placeholder="Re-enter Password"
                  type="text"
                />
              </div>

              <div className="col-md-6 col-12">
                <p className="account-text">
                  Already have an Account?{" "}
                  <span>
                    {" "}
                    <NavLink to="/login" className="login">
                      {" "}
                      Login{" "}
                    </NavLink>
                  </span>
                </p>
              </div>

              <div className="col-md-6 col-12 flex justify-center lg:justify-start">
                <button className="btn-cuppy">Update Password</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default updated;
